import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'panel',
    loadChildren: () =>
      import('./pages/panel/panel-pages-routing.module').then(
        (m) => m.PanelPagesRoutingModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./pages/app/app-pages-routing.module').then(
        (m) => m.AppPagesRoutingModule
      ),
  },
  { path: '**', redirectTo: '/' },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
